import React from "react";
import { Doughnut } from "react-chartjs-2";

function PieChart({ data, wrapperStyle }) {
  const chartData = {
    labels: data.map((item) => item.name),
    datasets: [
      {
        data: data.map((item) => item.percentage),
        backgroundColor: data.map((item) => item.color),
        hoverBackgroundColor: data.map((item) => item.color),
        borderWidth: 2,
        hoverBorderColor: "white",
        hoverBorderWidth: 2,
      },
    ],
  };

  const options = {
    // aspectRatio: 1, // make chart square
    cutout: 120, // make chart thinner
    // legend: {
    //     position: 'bottom',
    //     labels: {
    //         fontSize: 12,
    //         padding: 16,
    //     },
    // },
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          const label = data.labels[tooltipItem.index];
          const value = data.datasets[0].data[tooltipItem.index];
          return `${label}: ${value}%`;
        },
        afterLabel: function (tooltipItem, data) {
          var dataset = data["datasets"][0];
          var percent = Math.round(
            (dataset["data"][tooltipItem["index"]] /
              dataset["_meta"][0]["total"]) *
              100
          );
          return "(" + percent + "%)";
        },
      },
      backgroundColor: "#FFF",
      titleFontSize: 16,
      titleFontColor: "#0066ff",
      bodyFontColor: "#000",
      bodyFontSize: 14,
      displayColors: false,
    },
  };

  return (
    <div style={wrapperStyle}>
      <Doughnut data={chartData} options={options} />
    </div>
  );
}

export default PieChart;
